













import { Component, Vue, Prop } from "vue-property-decorator";

interface Header {
  text: string;
  value: string;
}

@Component
export default class CredentialTable extends Vue {
  @Prop({ required: true, type: Array }) items!: object[];
  @Prop({ required: true, type: String }) title!: string;

  get keys(): string[] {
    if (this.items.length === 0) return [];
    return Object.keys(this.items[0]);
  }

  get headers(): Header[] {
    return this.keys.map(k => this.h(k));
  }

  private h(key: string): Header {
    return { text: this.t(key), value: key };
  }

  private t(key: string): string {
    return this.$t("credentials.terms." + key).toString();
  }
}
